import { defineMessages } from 'react-intl';

export default defineMessages({
  announcementLabel: {
    id: 'announcement.announcementLabel',
    description: 'announcement label',
    defaultMessage: 'Announcements',
  },
  readMore: {
    id: 'announcement.readMore',
    description: 'read more link',
    defaultMessage: 'Read More',
  },
  readAcknowledge: {
    id: 'announcement.readAck',
    description: 'Read Acknowledgement',
    defaultMessage: 'By proceeding, you are acknowledging that you have read all announcements.',
  },
  showPrevMessagesLabel: {
    id: 'announcement.showPrevMessages',
    description: 'Show previous messages',
    defaultMessage: 'Show previous messages',
  },
  proceedLabel: {
    id: 'announcement.proceedLabel',
    description: 'proceed',
    defaultMessage: 'proceed',
  }
});
